module.exports = __webpack_public_path__ + "img/devices-sprite.fa7fba7a.svg";